"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgFileLink = function (props) { return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: 16, height: 21, fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M12.8 20.4H3.2a2.8 2.8 0 0 1-2.8-2.8V3.2A2.8 2.8 0 0 1 3.2.4h5.908a2.8 2.8 0 0 1 1.944.784l3.692 3.56A2.8 2.8 0 0 1 15.6 6.76V17.6a2.8 2.8 0 0 1-2.8 2.8Z", fill: "#250F7F", stroke: "#250F7F", strokeWidth: 0.8 }), (0, jsx_runtime_1.jsx)("path", { d: "M3.686 14.261h-.852V18H5.06v-.743H3.686V14.26ZM6.446 18v-3.739h-.851V18h.852Zm2.841-1.617-1.194-2.122h-.781V18h.852v-2.149L9.39 18h.749v-3.739h-.852v2.122Zm3.303-.271 1.242-1.85h-1.014l-.971 1.508V14.26h-.852V18h.852v-1.465L12.948 18h1.09l-1.448-1.888Z", fill: "#fff" })] }))); };
exports.default = SvgFileLink;
